module.exports = __webpack_public_path__ + "img/qq_erweima.78002298.jpg";